// removed by extract-text-webpack-plugin
module.exports = {"transparentButton":"_2GEL-VNy_ABg-Xv6VFRJvx","messages":"_1Rqkt3uXSokd-7YuYIJciZ","date":"_2-zzjZM2sY5ALVGb5Mhf26","container":"_2CsqVCcF4U_J7NaI99W_Ao","messageWrapper":"_3yXjFimKvXiugUinojaudd","messageBlock":"_1-RRyUnWY-zqXPc1CLafXx","message":"_2-ac2U2mwyz5JASFVGchm1","controls":"MXb1m6AzEgTcybd293jq3","title":"RjdAgVVBeSzXZVEVqpglG","messagesWrapper":"_3jS7FVM2p2-_tTX29X3Ogx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectDetailedInfo/MessageFromCompany/components/MessagesList/MessagesList.scss
// module id = 1708
// module chunks = 0